/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */

const DIGIT_MAP = {
  "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4",
  "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9",
  "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4",
  "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9",
};

/** Characters allowed to be typed into the slug field (before sanitizing). */
const SLUG_INPUT_CHAR = /^[a-zA-Z0-9\s\-_.٠-٩۰-۹]$/;

export function isAllowedSlugInputChar(char) {
  if (!char) return false;
  if (char.length > 1) {
    return [...char].every((c) => SLUG_INPUT_CHAR.test(c));
  }
  return SLUG_INPUT_CHAR.test(char);
}

/**
 * Normalize a store slug while typing.
 * Does not collapse "--" or strip edge hyphens so the caret stays in sync
 * on mobile (rejecting a keystroke with the same controlled value freezes IME).
 */
export function sanitizeStoreSlug(raw, { finalize = false } = {}) {
  if (raw == null) return "";

  let value = String(raw)
    .replace(/[٠-٩۰-۹]/g, (d) => DIGIT_MAP[d] || d)
    .toLowerCase()
    .replace(/[\s_.]+/g, "-")
    .replace(/[^a-z0-9-]/g, "");

  if (finalize) {
    value = value.replace(/--+/g, "-").replace(/^-+|-+$/g, "");
  }

  return value;
}
